import dayjs from "@/plugins/vue-dayjs";

export const initExpoEmployer = (form = {}) => ({
    ...(form || {}),

    _terms: [...(form?._terms || [])],

    _program: form?._program || null,
    _user: form?._user || null,

    info: {
        ...(form?.info || {}),

        desc: form?.info?.desc || null,
        body: form?.info?.body || null,

        name: form?.info?.name || null,

        site: form?.info?.site || null,
        phone: form?.info?.phone || null,
        email: form?.info?.email || null,
        worker: form?.info?.worker || null,

        postcode: form?.info?.postcode || null,
        address1: form?.info?.address1 || null,
        address2: form?.info?.address2 || null,
    },

    interview: {
        ...(form?.interview || {}),

        isOnline: form?.interview?.isOnline || false,
        location: form?.interview?.location || null,
        schedules: [...(form?.interview?.schedules || [])].sort((a, b) => (dayjs(a).isAfter(b) ? -1 : 1)),
    },
});
